import { NgModule } from '@angular/core';
import { ScormWrapperService } from './services';
import { WindowRef } from './services/window-ref';

@NgModule({
  providers: [
    ScormWrapperService,
    WindowRef
  ],
  exports: [
  ]
})
export class ScormWrapperModule {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/scorm-wrapper.module.ts